import type { RoleConfig } from '../types.js';

export const veteran: RoleConfig = {
  id: 'veteran',
  faction: 'town',
  title: { ru: 'Ветеран', uk: 'Ветеран' },
  latin: 'VETERAN',
  number: '17',
  accent: '#5a8a4a',
  ability: {
    ru: 'Три раза за игру может «встать на дозор» — убивает любого, кто посетит его этой ночью.',
    uk: 'Тричі за гру може стати «на варту» — вбиває кожного, хто прийде до нього вночі.',
  },
  abilities: [
    {
      key: 'alert',
      phase: 'night',
      cadence: 'every-night',
      shape: 'targetless',
      targetless: true,
      charges: 3,
    },
  ],
  victory: { type: 'town' },
};
